import {MenuNodeModel} from './menu-node.model';

export class Menu implements MenuNodeModel{

  constructor(public name: string,
              public icon: string,
              public nodes: MenuNodeModel[]) {}

  /**
   * Il menu è attivo se almeno un item è attivo.
   * @returns {boolean}
   */
  public isActive(): boolean {
    let active = false;
    this.nodes.forEach(node => {
      if (node.isActive()) {
        active = true;
      }
    });
    return active;
  }

  public getChildren(): MenuNodeModel[] {
    return this.nodes;
  }

  public isLeaf(): boolean {
    return false;
  }
}
